import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuthStore } from "@/store/auth.js";

export function AuthGuard({ children }: { children: React.ReactNode }) {
  const { user, checked, checkSession } = useAuthStore();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    checkSession();
  }, [checkSession]);

  useEffect(() => {
    if (checked && !user) {
      navigate("/login", {
        replace: true,
        state: { from: location.pathname },
      });
    }
  }, [checked, user, navigate, location.pathname]);

  if (!checked) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-6 w-6 animate-spin rounded-full border-2 border-brand-500 border-t-transparent" />
      </div>
    );
  }

  if (!user) return null;
  return <>{children}</>;
}
